'use client';

import type { UIComponentProps } from '@wolfejs/ui/types/UI';
import { CopyToClipboard as CopyToClipboardBase } from 'react-copy-to-clipboard';
import { cn } from '../utils/classnames';

export type CopyToClipboardProps = UIComponentProps &
  CopyToClipboard.Props & {
    text: string;
  };

export const CopyToClipboard = ({ className, children, text, ...otherProps }: CopyToClipboardProps) => {
  return (
    <span className={cn('"cursor-pointer"', className)}>
      <CopyToClipboardBase text={text} {...otherProps}>
        {children}
      </CopyToClipboardBase>
    </span>
  );
};
